import { commaJoined } from '@/lib/formatters/array.formatter'
import { formatPrice } from '@/lib/formatters/currency.formatter'
import { formatDate } from '@/lib/formatters/date.formatter'
import { formatFileSize } from '@/lib/formatters/file.formatter'
import type { i18n } from 'i18next'
import { fallbackLanguage, getSiteLocalization, supportedLanguages } from './site-locales'

export const fallbackLng = 'fr'
export const languages = [fallbackLng, 'en']
export const defaultNS = 'generic'

const siteLocalization = getSiteLocalization()

export const defaultTimeZone = siteLocalization.timeZone || 'UTC'

export const defaultLanguage = siteLocalization.language
export const defaultLocale = siteLocalization.locale || 'en-US'
export const defaultCountryCode = siteLocalization.phone.countryCode

export function initFormatters(i18n: i18n) {
  i18n.services.formatter?.add('price', (value) => formatPrice(value || 0))
  i18n.services.formatter?.add('dateLong', (value) => formatDate(value, 'LONG'))
  i18n.services.formatter?.add('dateCompact', (value) => formatDate(value, 'COMPACT'))
  i18n.services.formatter?.add('dateNormal', (value) => formatDate(value, 'NORMAL'))
  i18n.services.formatter?.add('dateFilename', (value) => formatDate(value, 'TIMESTAMP_FILENAME'))
  i18n.services.formatter?.add('dateCompactTime', (value) => formatDate(value, 'COMPACT_TIME'))
  i18n.services.formatter?.add('fileSize', (value) => formatFileSize(value))
  i18n.services.formatter?.add('commaJoined', (value) => commaJoined(value))
}

export const i18nConfig = {
  fallbackLng: fallbackLanguage,
  languages: supportedLanguages,
  defaultNS,
}
